export default function({ dispatch, commit }, data) {
    commit('startedAuthentication')

    // POST /auth/login
    return dispatch('post', {
        url: '/upgrade/verify',
        data
    }, {
        root: true
    })
    .then((result) => {
        commit('finishedAuthentication')
        commit('validatedUpgradeToken', result)
        return result
    })
    .catch((error) => {
        commit('finishedAuthentication')
        throw error
    })
}
